import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PageHomeOneComponent } from './pages/page-home-one/page-home-one.component';
import { RootComponent } from './components/root/root.component';
import { AuthGuard } from 'src/app/shared/guard';
import { PageProductComponent } from './modules/shop/pages/page-product/page-product.component';
import { ProductResolverService } from './modules/shop/resolvers/product-resolver.service';
import { Nopage404Component } from './shared/components/nopage404/nopage404.component';



const routes: Routes = [
    {
        path: '',
        component: RootComponent,
        data: {
            // Header layout. Choose one of ['classic', 'compact'].
            headerLayout: 'classic',
            // Dropcart type. Choose one of ['dropdown', 'offcanvas'].
            dropcartType: 'dropdown'
        },
        children: [
            {
                path: '',
                pathMatch: 'full',
                component: PageHomeOneComponent
            },
            {
                path: 'auth',
                loadChildren: () => import('./modules/auth/auth.module').then(m => m.AuthModule)
            },
            {
                path: 'dashboard',
                loadChildren: () => import('./modules/dashboard/dashboard.module').then(m => m.DashboardModule),
                canActivate: [AuthGuard]
            },
            {
                path: 'home',
                loadChildren: () => import('./modules/home/home.module').then(m => m.HomeModule)
            },
            {
                path: 'shop',
                loadChildren: () => import('./modules/shop/shop.module').then(m => m.ShopModule)
            },
            {
                path: 'brands',
                loadChildren: () => import('./modules/brands/brands.module').then(m => m.BrandsModule)
            },
            {
                path: 'tags',
                loadChildren: () => import('./modules/tags/tags.module').then(m => m.TagsModule)
            },
            {
                path: 'search',
                loadChildren: () => import('./modules/search/search.module').then(m => m.SearchModule)
            },
            {
                path: ':productSlug',
                component: PageProductComponent,
                data: {
                    // Product page layout. Possible values: 'standard', 'columnar', 'sidebar'.
                    layout: 'standard',
                    // Sidebar position. Possible values: 'start', 'end'.
                    // It does not matter if the value of the 'layout' parameter is not 'sidebar'.
                    // For LTR scripts "start" is "left" and "end" is "right".
                    sidebarPosition: 'start'
                },
                resolve: {
                    product: ProductResolverService
                },
            }
        ],
    },
    {
        path: '**',
        pathMatch: 'full',
        component: Nopage404Component
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled',
    anchorScrolling: 'enabled',
    initialNavigation: 'enabledNonBlocking',
    relativeLinkResolution: 'legacy'
})],
    exports: [RouterModule],
    providers: [AuthGuard]
})
export class AppRoutingModule { }
